import { render, staticRenderFns } from "./PaycoConfigIframe.vue?vue&type=template&id=648cb46b&"
import script from "./PaycoConfigIframe.vue?vue&type=script&lang=ts&"
export * from "./PaycoConfigIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports